var map = {
	"./icon-arrow.svg": 95361,
	"./icon-arrow1.svg": 52594,
	"./icon-arrow2.svg": 41281,
	"./icon-close-invite.svg": 66416,
	"./icon-close.svg": 15686,
	"./icon-copy.svg": 38385,
	"./icon-lfg.svg": 4015,
	"./icon-refresh.svg": 30303,
	"./icon-telegram.svg": 29611,
	"./icon-twitter.svg": 74731,
	"./icon-vector.svg": 89295,
	"./icon-vector1.svg": 31340,
	"./icon-vector2.svg": 10367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;